import clsx from 'clsx';
import { Tooltip } from '../Tooltip';

interface StatusDotProps {
  color: string;
  statusText?: string;
  className?: string;
  tooltipId?: string;
}

const statusColors: Record<string, string> = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  red: 'bg-red-500',
  gray: 'bg-gray-500',
};

export const StatusDot = ({
  color,
  statusText,
  className,
  tooltipId,
}: StatusDotProps) => {
  if (!statusText || !tooltipId) {
    return null;
  }

  return (
    <>
      <Tooltip content={statusText} anchor={`#${tooltipId}`} />
      <span className={clsx('inline-block', className)} id={tooltipId}>
        <span
          className={clsx(
            'block w-2 h-2 rounded-full',
            statusColors[color],
          )}></span>
      </span>
    </>
  );
};
